// extracted by mini-css-extract-plugin
module.exports = {"MobileNav":"mobile-navigation_MobileNav__1-JCD"};